import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import type { TooltipProps } from 'recharts';

interface ChartProps {
  data: ChartDataPoint[]
}

interface ChartDataPoint {
  name: string
  attendance: number
  testAttempts?: number
}

const CustomTooltip: React.FC<TooltipProps<number, string>> = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload as ChartDataPoint;
    return (
      <div className="custom-tooltip" style={{ background: '#fff', padding: '10px', border: '1px solid #ccc', borderRadius: '4px' }}>
        <p className="label" style={{ fontWeight: 600, marginBottom: 5 }}>{data.name}</p>
        <p className="intro" style={{ color: '#830206', margin: 2 }}>Посещаемость: {data.attendance}</p>
        {data.testAttempts !== undefined && <p className="intro" style={{ color: '#1890ff', margin: 2 }}>Пройдено тестов: {data.testAttempts}</p>}
      </div>
    );
  }
  return null;
};

const Chart: React.FC<ChartProps> = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart
        width={500}
        height={400}
        data={data}
        margin={{
          top: 10,
          right: 30,
          left: 0,
          bottom: 0,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip content={<CustomTooltip />} />
        <Area type="monotone" dataKey="attendance" stroke="#830206" fill="#F6E6E7" />
        {data && data[0]?.testAttempts !== undefined && (
          <Area type="monotone" dataKey="testAttempts" stroke="#1890ff" fill="#E6F7FF" />
        )}
      </AreaChart>
    </ResponsiveContainer>
  )
}

export default Chart;